import * as React from "react";
import { Consumer } from "../libs/AuthContext";
import { Segment, Menu, Modal, Button , Icon, Dimmer} from "semantic-ui-react";
import Sidebar from "../components/Sidebar";
import Settings from "../components/Settings";
import Storage from "@aws-amplify/storage";
import config from "../config";
import { translate } from "react-i18next";
import { getLocations, fileData } from "../libs/utility";
import {navigate} from "gatsby"

class MobileHeader extends React.Component {
  rendererOptions =
  [
    { key: "flipbookRenderer", text: "Flip Book", value: "flipbookRenderer" },
    { key: "stackRenderer", text: "Stack", value: "stackRenderer" },
    { key: "verticalScrollRenderer", text: "Vertical Scroll", value: "verticalScrollRenderer" }
  ]
  constructor(props ) {
    super(props);
    this.pubLoader = this.props.context.pubLoader
    this.state ={
       confirmLogout: false,
       showSideBar: false,
       showSettings: false,
       confirmQuit: false,
       isLoading: false,
       showBookmarks: false,
       bookmarkFile: null,
       renderer: "flipbookRenderer"
    }
  }

 handleQuit = async () => {
    let timeline = this.pubLoader.getView().getTimeline();
    let savedLocations = await getLocations();
    if (savedLocations && timeline) {
      let dirty = false;
      let end = timeline.getCurrentSegment().end;
      savedLocations.forEach(
        item => {
          if (item.id === this.props.bookId) {
            dirty = true;
            item.location = end.toString()
          }
        }
      )
      if (!dirty) {
        console.log(end.toString())
        savedLocations =[...savedLocations,
            {
            id: this.props.bookId,
            location: end.toString()
            }
          ]
      }
      await Storage.put("savedLocation.json", JSON.stringify (savedLocations), {
           bucket: config.s3.BUCKET, level: "private"
        }, );
      }

    navigate("/");
  }

 showConfirm = () => {
    this.setState({ confirmQuit: true })
  }

 handleCancel = () => {
    this.setState({ confirmQuit: false })
  }

 addBookmark = async () => {
    const {t } = this.props;
    let timeline = this.pubLoader.getView().getTimeline();
    console.log(timeline);
    if (timeline) {
      let fileId = await this.currentLocation();
      let bookmarks = await fileData(this.props.bookId+".json");
      if (bookmarks) {
          bookmarks =[...bookmarks,
             {
             id: fileId,
             location: timeline.getCurrentSegment().end
             }]
      }
      else {
        console.log("no file yet")
        bookmarks =[
            {
            id: fileId,
            location: timeline.getCurrentSegment().end
            }]
      }
      console.log(bookmarks);
      await Storage.put(this.props.bookId+".json", JSON.stringify (bookmarks), {bucket: config.s3.BUCKET, level: "private"});
    }
    alert(t("Bookmark Added"));
  }


 async currentLocation () {
    let temp = this.pubLoader.getView().getVisiblePages()
    let response = null
    if (temp) {
      try {
       response = await temp[0].getReaderDocument().fetchContentBlocks()
       console.log(response);
       if (response && response[0].blockClass === "TEXT") {
        return response[0] ? response[0].textContent : ""
       }
       if (response && response[0].blockClass === "CONTAINER") {
        return response[0].children ? response[0].children[0].textContent+" : "+response[0].children[1].textContent : ""
       }
       else if (response && response[0].blockClass === "MEDIA") {
         return response[1] ? response[1].textContent : ""
       }
      } catch (e) {
        console.log(e);
      }
    }
  }

  getBookmarks = async () => {
    try {
      let bookmarks = await fileData(this.props.bookId+".json");
        if (bookmarks) {
          let timeline = this.pubLoader.getView().getTimeline();
          bookmarks.map(
            async (id) =>
            id.location = timeline ? await timeline.fetchAnnotationTargetFromPosition(id.location) : null
          )
          this.setState({bookmarkFile: bookmarks})
        }
      } catch (e) {
        console.log(e);
      }
    this.setState({showBookmarks: !this.state.showBookmarks})
  }

 renderBookmarks() {
    if (this.state.bookmarkFile){
    return [{}].concat(this.state.bookmarkFile).map(
      (id, index) =>
        index !== 0
        ?
          <div key={index}>
          <Button className="bookmarkGo" style={{borderRadius: "0em"}} onClick={() => {
            this.setState({showBookmarks : !this.state.showBookmarks})
            this.pubLoader.getView().goTo(id.location)}
            }
            >
            {id.id.substring(0, 100 )+"..."}
            </Button>
          </div>
        : null
    );
    }
    else {
      return null
    }
  }

 updateRenderer = (event,data) => {
    let view = this.pubLoader.getView()
    let newRenderer = view.getRendererByName(data.value);
    if (newRenderer) {
        view.setActiveRenderer(newRenderer);
        this.pubLoader.renderer = data.value;
    }
    this.setState({ renderer: data.value})
    view.setRendererOptions({})
    view.refresh();
  }



 render () {
    const { t } = this.props
    return (
      <Dimmer.Dimmable dimmed={this.state.isLoading}>
        <Segment style={{width: "100%", padding: "0em"}}>
        {this.pubLoader.epubTitle}
          <Menu fixed="top" fluid borderless size="large" as="nav" className="readerHeader">
            <Menu.Item>
                <Modal
                style={{backgroundColor: "transparent"}}
                basic
                size="tiny"
                open={this.state.confirmQuit}
                onOpen={this.showConfirm}
                trigger={<Button
                  icon="arrow left"
                  className="exitButton"
                  style={{paddingRight: "0em"}}
                  />
                  }
                >
              <Modal.Header>{t("Are you sure you want to return to your library?")}</Modal.Header>
              <Modal.Actions>
                <Button onClick={this.handleQuit} className="secondaryButton" >
                  {t("Yes")}
                </Button>
                <Button onClick={this.handleCancel} className="cancelButton">
                  {t("Cancel")}
                </Button>
              </Modal.Actions>
              </Modal>
            </Menu.Item>
            <Menu.Item style={{paddingLeft: "0em", paddingRight: "1em"}}>
                <Icon inverted name="sidebar" size="large"
                  onClick={() => {this.setState({showSideBar: !this.state.showSideBar, showSettings: false}) }}
                />
                {this.state.showSideBar &&
                  <Menu vertical fixed="left" className="sideSettings">
                    <br/>
                    <Sidebar
                    />
                    </Menu>
                }
            </Menu.Item>
            <Menu.Item style={{paddingLeft: "0em", paddingRight: "1em"}}>
              <Modal
              className="bookModal"
              basic
              size="small"
              open={this.state.showBookmarks}
              onClose={() => this.setState({showBookmarks: !this.state.showBookmarks})}
              closeOnDocumentClick={true}
              closeIcon
              trigger={<Icon className="settings"
                name="file alternate outline"
                size="large"
                onClick={this.getBookmarks}
                float={"left"}
                style={{paddingLeft: "0em"}}
                />
                }
              >
            <Modal.Header  style={{textAlign: "center", fontSize: "2em"}}>{t("Bookmarks")}</Modal.Header>
            <Modal.Content>
              {this.renderBookmarks()}
            </Modal.Content>
            </Modal>
            </Menu.Item>
            <Menu.Item style={{paddingLeft: "0em", paddingRight: "1em"}}>
                <Icon inverted name="bookmark outline" size="large"
                  onClick={this.addBookmark}
                />
            </Menu.Item>
            <Menu.Menu position="right">
              <Menu.Item>
                <Modal
                className="bookModal"
                basic
                size="tiny"
                open={this.state.showSettings}
                onClose={() => this.setState({showSettings: !this.state.showSettings})}
                closeOnDocumentClick={true}
                closeIcon
                trigger={<Button icon className="settings"
                  onClick={() => {this.setState({showSettings: !this.state.showSettings, showSideBar: false}) }}
                  >
                  <Icon inverted name="setting" style={{paddingRight: "1.5em"}}/>
                  </Button>
                  }
                >
              <Modal.Header style={{textAlign: "center", fontSize: "2em"}}>{t("Settings")}</Modal.Header>
              <Modal.Content>
              <Settings
                {...this.props}
              />
              </Modal.Content>
              </Modal>
              </Menu.Item>
              </Menu.Menu>
            </Menu>
          </Segment>
        </Dimmer.Dimmable>
    )
  }

}

export default translate("translations")(props =>
  <Consumer>
    {value => <MobileHeader {...props} context={value} />}
  </Consumer>

);
